<cap-list-loader [hasRight]="hasRight" [listLoader]="listLoader" [showTotal]="false" [showZeilenSelect]="false">
  <div class="cap-list-loader-content">
    <table class="cap-table-detail">
      <thead>
        <ng-template [ngTemplateOutlet]="tableHeadersFlaechenanteile"></ng-template>
      </thead>
      <tbody>
        <ng-template [ngTemplateOutlet]="tableRowsFlaechenanteile"></ng-template>
      </tbody>
    </table>
  </div>
</cap-list-loader>
<ng-template #tableHeadersFlaechenanteile>
  <tr>
    <th style="width: 40%">{{ "Art" | translate }}</th>
    <th [ngStyle]="{ width: showFlaeche ? '40%;' : '60%;' }">{{ "Grundstueck" | translate }}</th>
    @if (showFlaeche) {
      <th colspan="2">{{ "Abschnittflaeche" | translate }}</th>
    }
  </tr>
</ng-template>
<ng-template #tableRowsFlaechenanteile>
  @if (listLoader?.items) {
    @for (flaechenanteil of listLoader?.items; track flaechenanteil) {
      @for (version of flaechenanteil.versions; track version) {
        <tr>
          <td>
            @if (flaechenanteil.sdrGrundstueck?.id.id === grundstueckId.id) {
              <span [capHistinfo]="version.histInfo">
                {{ "LastetAuf" | translate }}
              </span>
            }
            @if (flaechenanteil.grundstueck?.id.id === grundstueckId.id) {
              <span [capHistinfo]="version.histInfo">
                {{ "BelastetMit" | translate }}
              </span>
            }
          </td>
          <td>
            @if (flaechenanteil.sdrGrundstueck?.id.id === grundstueckId.id) {
              <span [capHistinfo]="version.histInfo">
                @if (flaechenanteil.grundstueck) {
                  <cap-kompakt-grundstueck [item]="flaechenanteil.grundstueck" [navigateTo]="navigateTo"> </cap-kompakt-grundstueck>
                }
              </span>
            }
            @if (flaechenanteil.grundstueck?.id.id === grundstueckId.id) {
              <span [capHistinfo]="version.histInfo">
                @if (flaechenanteil.sdrGrundstueck) {
                  <cap-kompakt-grundstueck [item]="flaechenanteil.sdrGrundstueck" [navigateTo]="navigateTo"> </cap-kompakt-grundstueck>
                }
              </span>
            }
            @if (flaechenanteil.grundstueck) {
              <cap-kompakt-timepoint [item]="version.histInfo?.bisTimePoint" loeschgeschaeft></cap-kompakt-timepoint>
            }
          </td>
          @if (showFlaeche) {
            <td style="width: 1%">
              <div class="text-end">
                <span [capHistinfo]="version.histInfo"> {{ version.flaecheQuadratmeter | decimalHochkomma }}&nbsp;m² </span>
              </div>
            </td>
          }
          @if (showFlaeche) {
            <td>
              <cap-kompakt-timepoint [item]="version.histInfo?.bisTimePoint" loeschgeschaeft></cap-kompakt-timepoint>
            </td>
          }
        </tr>
      }
    }
  }
</ng-template>
